
import axios from 'axios'
import store from './../store/index'
import router from './../router'
import { Message } from 'element-ui'

// http request 拦截器
axios.interceptors.request.use(
    config => {
        return config;
    },
    err => {
        return Promise.reject(err);
    });
 
// http response 拦截器
axios.interceptors.response.use(
    response => {
       //登录超时重新登录 
       // query: {redirect: router.currentRoute.fullPath}
        if(response.status === 200 && response.data.code === 500 && response.data.msg === '未登录'){
            store.dispatch('Logout');
            store.dispatch("RestSchoolData");
            Message.error({message: '登录超时，请重新登录'})
            router.replace({
                path: '/main/home',
                query: {redirect: router.currentRoute.fullPath}
            });
        }    
        return response;
    },error => {
        // if(error.response.status === 504){
        //     Message.error({message: '服务器可能未开启,请稍后再试'});
        // }else if(error.response.status===401){
        //     Message.error({message:"登录超时，请重新登录"});
        //     store.dispatch('Logout');
        //     store.dispatch("RestSchoolData");
        //     router.replace({
        //         path: '/main/home',
        //         query: {redirect: router.currentRoute.fullPath}
        //     });
        // }
        return Promise.reject(error)   // 返回接口返回的错误信息
    });
    let tokenObj=localStorage.getItem("token");
    if(tokenObj){
        tokenObj=JSON.parse(tokenObj);
    }
const token=tokenObj?"Bearer "+tokenObj.token:"";
const axiosObj={
        BASE_URL: '/api',
        headers: {
           'Content-Type': 'application/json; charset=utf-8',
           Authorization:token
         }
};
const http=axios.create(axiosObj);
export default axios;